export enum PeriodConditionsTypeEnum {
  DateInterval = 'DateInterval',
  DayOfMonth = 'DayOfMonth',
  DayOfWeek = 'DayOfWeek',
  TimeInterval = 'TimeInterval',
}
